module.exports = __webpack_public_path__ + "media/rbs_video.f437ed32.mp4";